import React from "react";
import CardList from "../List_Event/CardList";

export default function Recommendation({ events }) {
    const renderCardList = (events) => {
        if (events.length !== 0) {
            return (
                <div className="container event-container">
                    <CardList events={events} />
                </div>
            )
        } else {
            return (
                <div className="text-center mt-4">
                    <h6 className="font-weight-bold text-muted">Belum ada rekomendasi</h6>
                </div>
            )
        }
    }

    return (
        <section id="recommendation" style={{
            background: "linear-gradient(185deg, #2D2D44 45.15%, #2B606F 79.44%)"
        }}>
            <div className="container">
                <hr />
                <h5 className="text-light">Rekomendasi Event Lainnya</h5>
            </div>
            {renderCardList(events)}
        </section>
    );
}
